// import React from 'react';
// import { NavLink } from 'react-router-dom';
// import { NewMenuItems } from './NewSlideItems/NewSlide';

// function NewMenubar({ link, label, icon }) {
//   return (
//     <li className="mm">
//       <NavLink to={link} className="mm-link" activeClassName="mm-active">
//         <div className="menu-icon">{icon}</div>
//         <span className="nav-text">{label}</span>
//       </NavLink>
//     </li>
//   );
// }

// const NewSlideBar = () => {
//   return (
//     <>
//       {/* Sidebar Start */}
//       <div className="deznav">
//         <div className="deznav-scroll mm-active">
//           <ul className="metismenu mm-show" id="menu">
//             <li className="menu-title">Tableau de bord</li>

//             {/* Éléments dynamiques */}
//             {NewMenuItems.map((item, index) => (
//               <NewMenubar
//                 key={index}
//                 link={item.link}
//                 label={item.label}
//                 icon={item.icon}
//               />
//             ))}

//             {/* Dropdown : Projets en un clic */}
//             <li className="mm">
//               <a href="#" className="has-arrow">
//                 <div className="menu-icon">
//                   <i className="fas fa-folder"></i>
//                 </div>
//                 <span className="nav-text">Projets en un clic</span>
//               </a>
//               <ul>
//                 <li><NavLink to="/quote">Devis</NavLink></li>
//                 <li><NavLink to="/project">Projects</NavLink></li>
//                 <li><NavLink to="/projet">Create Project</NavLink></li>
//               </ul>
//             </li>

//             {/* Dropdown : Bureau d'Étude */}
//             <li className="mm">
//               <a href="#" className="has-arrow">
//                 <div className="menu-icon">
//                   <i className="fas fa-cogs"></i>
//                 </div>
//                 <span className="nav-text">Bureau d'Étude</span>
//               </a>
//               <ul>
//                 <li><NavLink to="/">Statistique</NavLink></li>
//                 <li><NavLink to="/bureau-etude">Étapes</NavLink></li>
//               </ul>
//             </li>
//           </ul>
//         </div>
//       </div>
//       {/* Sidebar End */}
//     </>
//   );
// };

// export default NewSlideBar;


import React, { useEffect, useState } from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import { NewMenuItems } from './NewSlideItems/NewSlide';
import { FaChevronDown } from 'react-icons/fa';

const NewSlideBar = () => {
  const [activeMenu, setActiveMenu] = useState(null);
  const location = useLocation();

  // À l'initialisation, active automatiquement le menu contenant le lien courant
  useEffect(() => {
    const path = location.pathname;

    const foundMenu = NewMenuItems.find((menu) =>
      menu.subMenu?.some((sub) => sub.link === path)
    );

    if (foundMenu) {
      setActiveMenu(foundMenu.id);
    }
  }, [location.pathname]);

  const toggleMenu = (id) => {
    setActiveMenu((prev) => (prev === id ? null : id));
  };

  return (
    <div className="deznav">
      <div className="deznav-scroll">
        <ul className="metismenu mm-show" id="menu">
          <li className="menu-title">Tableau de bord</li>

          {NewMenuItems.map((menu) => {
            const hasSubMenu = menu.subMenu && menu.subMenu.length > 0;

            return (
              <li className="mm" key={menu.id}>
                {hasSubMenu ? (
                  <>
                    <button
                      type="button"
                      onClick={() => toggleMenu(menu.id)}
                      className="has-arrow d-flex align-items-center justify-content-between w-100"
                      style={{
                        background: 'none',
                        border: 'none',
                        color: 'white',
                        padding: '0.75rem 1rem',
                        textAlign: 'left',
                        cursor: 'pointer',
                        fontSize: '16px'
                      }}
                    >
                      <div className="d-flex align-items-center">
                        <div className="menu-icon me-2">{menu.icon}</div>
                        <span className="nav-text">{menu.label}</span>
                      </div>
                      <FaChevronDown
                        style={{
                          transform: activeMenu === menu.id ? 'rotate(180deg)' : 'rotate(0deg)',
                          transition: 'transform 0.3s'
                        }}
                      />
                    </button>

                    <ul style={{ display: activeMenu === menu.id ? 'block' : 'none' }}>
                      {menu.subMenu.map((sub) => (
                        <li key={sub.id}>
                          <NavLink
                            to={sub.link}
                            className={({ isActive }) => (isActive ? 'active' : '')}
                            style={{
                              display: 'flex',
                              alignItems: 'center',
                              padding: '0.5rem 1rem',
                              color: 'white',
                              textDecoration: 'none',
                            }}
                          >
                            <span className="menu-icon me-2">{sub.icon}</span>
                            <span className="nav-text">{sub.label}</span>
                          </NavLink>
                        </li>
                      ))}
                    </ul>
                  </>
                ) : (
                  <NavLink
                    to={menu.link}
                    className={({ isActive }) => `d-flex align-items-center ${isActive ? 'active' : ''}`}
                    style={{
                      padding: '0.75rem 1rem',
                      textDecoration: 'none',
                      color: 'white'
                    }}
                  >
                    <div className="menu-icon me-2">{menu.icon}</div>
                    <span className="nav-text">{menu.label}</span>
                  </NavLink>
                )}
              </li>
            );
          })}
        </ul>
      </div>
    </div>
  );
};

export default NewSlideBar;